import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";

const Component = loadable(async () => {
    const ServiceScheduler = await import("@lexus.com/ui/dist/applications/ServiceScheduler")
    return ServiceScheduler;
});

const SchedulerToolEditConfig = {
    emptyLabel: "Service Scheduler Tool",
    isEmpty: function (props) {
        return !props || !props.title || props.title.trim().length < 1;
    },
};


/**
 * Temp fn to build paths for the sst-icons
 */
const getIconPath = (source) => {
    if (source === 'LCOM') {
        return '/content/dam/lexus/images/icons/sst-icons';
    } else if (source === 'TCOM') {
         return '/content/dam/toyota/sst/icons';
    } else {
        return null;
    }
}

/**
 * TODO: Replace all of the hard-coded HTML within the strings returned
 * by this function. If there are authored values for this, find out why
 * they aren't used here.
 */
const transformProcessStepper = ({
    general,
    viewAppointmentsCTA,
    theme
}, iconPath) => {

    // Validate steps
    if (!general || !general.stepNameList) {
        return {
            currentStep: 0,
            steps: [],
        };
    }


    let processedSteps = general?.steps || [];
    processedSteps = processedSteps.map((step) => ({
        stepName: step?.name,
        stepText: step?.text,
        href: step?.href,
        nextStepText: step?.nextStepText,
        btnStepText: step?.btnStepText,
    }));



    const isLexus = theme === "LCOM";
    const { currentStep, currentStepMobile, nextStep, successfulAppointmentModal, failedAppointmentModal, mileageDisclaimer, summaryDisclaimer } = general;
    const steps = processedSteps.map((currentStepObj, index) => {


        const currentStepLabel = currentStepObj.stepText
        const href = currentStepObj.href
        const nextStepLabel = currentStepObj?.nextStepText || processedSteps[index + 1]?.stepText;
        const nextBtnStepText = processedSteps[index + 1]?.btnStepText || processedSteps[index + 1]?.stepText

        return {
            stepText: currentStep,
            currentStepLabel,
            nextLabel: nextStep,
            mobileStepText: currentStepMobile,
            nextStepLabel,
            nextBtnStepText,
            href
        }
    });

    const successfulAppointmentProps = {
        icon: successfulAppointmentModal?.icon?.src,
        title: successfulAppointmentModal?.heading  || (isLexus ? "APPOINTMENT CONFIRMED" : "Appointment Confirmed"),
        subtitle: successfulAppointmentModal?.body || 'Your service appointment has been scheduled, please check your email for updates from your dealer.',
        ctas: successfulAppointmentModal?.ctas?.length > 0 ? successfulAppointmentModal.ctas.map(cta => ({ ...cta, disableRouter: true })) : [
            {
                             "type": "button",
                             text: isLexus ? 'VIEW MY APPOINTMENTS' : `View My Appointments <Icon src="${iconPath}/iconArrowRight.svg"/>`,
                             "href": viewAppointmentsCTA.href,
                             "target": "_self",
                             "theme":  isLexus ? 'SecondaryBlack' : 'ToyotaSSTTransparent',
                             "isActive": false,
                             "disableRouter":true,
            }
        ]
    }

    const failedAppointmentProps = {
        icon: failedAppointmentModal?.icon?.src || ((!isLexus) && `${iconPath}/fail.svg` ),
        title: failedAppointmentModal?.heading || (!isLexus) ? "Something Went Wrong" : "SOMETHING WENT WRONG",
        subtitle: (failedAppointmentModal?.body ) || (!isLexus)  ? '<p>There was an issue confirming the appointment and it wasn\'t booked. Please try making a new appointment.</p>\n<p>If this problem persists, please contact {dealerName} at&nbsp; <a href={\`tel:\${phoneNumber}\`}>{phoneNumber}</a> directly to book the appointment.</p>\n' : // NOSONAR for this bespoke string parsing logic
        `<p>There was an issue booking your appointment, please try again. </p>\n<p>If this problem persists, please contact {dealerName} at&nbsp; <a href={\`tel:\${phoneNumber}\`}>{phoneNumber}</a> directly to book the appointment.</p>\n`,
        ctas: (!isLexus) ? [
            {
                "type": "button",
                "text": "Book New Appointment",
                "href": "{bookNewAppointment}",
                "target": "_self",
                "theme": "ToyotaBlack",
                "isActive": false
                },
                {
                    "type": "button",
                    "text": "View My Appointments",
                    "href": viewAppointmentsCTA.href,
                    "target": "_self",
                    "theme": "ToyotaWhite",
                    "isActive": false
                }
        ] : [
            {
                "type": "button",
                "text": "BOOK NEW APPOINTMENT",
                "href": "{bookNewAppointment}",
                "target": "_self",
                "theme": "PrimaryBlack",
                "isActive": false
            },
            {
                "type": "text",
                "text": "VIEW MY APPOINTMENTS",
                "href": viewAppointmentsCTA.href,
                "target": "_self",
                "theme": "SecondaryBlack",
                "isActive": false
            }
        ]
    }

    const failedEditAppointmentProps = {
            icon:  !isLexus ? `${iconPath}/fail.svg` : undefined,
            title:  !isLexus ? "Something Went Wrong" : "SOMETHING WENT WRONG",
            subtitle: `<p>There was an issue updating the appointment. Please try again.</p>\n<p>If this problem persists, please contact {dealerName} at&nbsp; <a href={\`tel:\${phoneNumber}\`}>{phoneNumber}</a> directly to update the appointment.</p>\n`,
            ctas: !isLexus? [
                {
                    "type": "button",
                    "text": "Try Again",
                    "href": "{tryAgain}",
                    "target": "_self",
                    "theme": "ToyotaBlack",
                    "isActive": false
                    },
                    {
                        "type": "button",
                        "text": "View My Appointments",
                        "href": viewAppointmentsCTA.href,
                        "target": "_self",
                        "theme": "ToyotaWhite",
                        "isActive": false
                    }
            ] : [
                {
                    "type": "button",
                    "text": "TRY AGAIN",
                    "href": "{tryAgain}",
                    "target": "_self",
                    "theme": "PrimaryBlack",
                    "isActive": false
                },
                {
                    "type": "text",
                    "text": "VIEW MY APPOINTMENTS",
                    "href": viewAppointmentsCTA.href,
                    "target": "_self",
                    "theme": "SecondaryBlack",
                    "isActive": false
                }
            ]
        }

    

    return {
        currentStep: 0,
        steps,
        backCtaCopy: general?.backCtaCopy,
        nextStepCtaCopy: general?.nextStepCtaCopy,
        summaryPage: '/summary',
        successfulAppointment: successfulAppointmentProps,
        failedAppointment: failedAppointmentProps,
        mileageDisclaimer,
        summaryDisclaimer,
        failedEditAppointmentProps
    };
};

const transformDealerPage = ({ dealer, general, theme }, iconPath) => {
    const telephoneNames = (dealer?.phoneNumbers || []).map(phoneNumber => ({
        key: phoneNumber.key,
        displayName: phoneNumber.label || ""
    }));
    const isLexus = theme === "LCOM";
    return {
        theme: {
            brand: theme === 'LCOM' ? 'Lexus' : 'Toyota',
        },
        missingDealerHeading: dealer?.missingDealerHeading || (theme === 'LCOM' ? "PLEASE SELECT THE DEALER FOR YOUR SERVICE APPOINTMENT" : undefined),
        missingDealerIcon: {
            iconColor: "#666766",
            iconUrl: dealer?.missingDealerIcon?.src,
        },
        missingDealerCTA: dealer?.missingDealerCTA?.text,
        isMapEnabled: general?.isMapEnabled,
        mergeDealerMileageSteps: general?.mergeDealerMileageSteps, // may need to remove
        heading: dealer?.heading,
        subheading: dealer?.subHeading,
        CTALabel: dealer?.changeDealerCTACopy,
        dealerDetailsCTACopy: dealer?.dealerDetailsCTA?.text,
        preferredDealerText: dealer?.preferredDealerLabel,
        spanishSpeakingText: dealer?.spanishSpeakingCopy,
        serviceHoursLabel: dealer?.allServicingHoursCopy,
        hoursLabel: dealer?.todaysHoursCopy,
        websiteText: dealer?.visitWebsiteCopy,
        selectDealerLabel: dealer?.searchHeading,
        selectDealerCTA: dealer?.selectDealerCTA?.text,
        smartPathCopy: dealer?.smartPathDescription,
        loadMoreLabel: dealer?.loadMoreCTA?.text,
        searchButtonText: dealer?.updateCTA?.text,
        dealerDetailsHeadingText: dealer?.dealerDetailsHeadingText || "DEALER DETAILS",
        dealerSectionSubheading: dealer?.subheadingSection || "DEALER INFORMATION",
        maxOverallAppointments: {
            title: general?.maxAppointmentsHeading,
            body: general?.maxAppointments,
            iconColor: "",
            iconUrl: general?.maxAppointmentsIcon?.src,
            CTAButtonLabel: general?.maxAppointmentsCTA?.text,
            CTAButtonRedirect: general?.maxAppointmentsCTA?.href,
            CTAButtonTheme: general?.maxAppointmentsCTA?.theme
        },
        successChangePreferredDealer: {
            title: general?.successChangePreferredDealer?.tilte || isLexus ? "PREFERRED DEALER UPDATED" :"Preferred Dealer Updated",
            body: general?.successChangePreferredDealer?.body || "Your preferred dealer location has been updated to {currentDealer}",
            iconColor: "",
            iconUrl: general?.successChangePreferredDealer?.icon || general?.successfulAppointmentModal?.icon?.src,
            CTAButtonLabel: general?.successChangePreferredDealer?.CTACopy || isLexus ? "CLOSE" : "Close",
            CTAButtonTheme:general?.successChangePreferredDealer?.CTATheme || isLexus ? "PrimaryBlack" : "ToyotaWhite"
        },
        errorChangePreferredDealer:{
            title: general?.successChangePreferredDealer?.tilte || isLexus  ? "PREFERRED DEALER CANNOT BE UPDATED AT THIS TIME" : "Preferred Dealer cannot be updated at this time",
            body: general?.errorChangePreferredDealer?.body || isLexus ? `There's been an error with updating your preferred dealer. Please contact <a href="https://www.lexus.com/contact">customer support</a>` : `There's been an error with updating your preferred dealer. Please contact <a href="https://www.toyota.com/support/contact-us/">customer support</a>`,
            iconColor: "",
            iconUrl: general?.errorChangePreferredDealer?.icon || general?.failedAppointmentModal?.icon?.src,
            CTAButtonLabel: general?.errorChangePreferredDealer?.CTACopy || isLexus ? "CLOSE":"Close",
            CTAButtonTheme:general?.errorChangePreferredDealer?.CTATheme || isLexus ? "PrimaryBlack" : "ToyotaWhite"
        },
        noOnlineSchedulingAvailable:{
		title: isLexus ? "ONLINE SCHEDULING NOT CURRENTLY AVAILABLE FOR THIS DEALER" : "Online scheduling not currently available for this dealer",
		subtitle:
			"Please contact {dealerName} at <a href={`tel:${phoneNumber}`}>{phoneNumber}</a> to make an appointment, or select another dealer.",
        noPhoneNumberSubheader: "Please contact {dealerName} to make an appointment, or select another dealer.",
		icon:isLexus ? undefined : `${iconPath}/building.svg`,
            
		ctas: isLexus ?  [
			{
				type: "button",
				text:  "VISIT DEALER WEBSITE" ,
				theme: "PrimaryBlack",
				isActive: true,
				disableRouter: true,
				href: "{redirect}",
			},
            {
				type:"link",
				text:"CHANGE DEALER",
				theme: "PrimaryBlack" ,
				isActive: true,
				href: "{showChangeDealer}",
			},
		] :  [
            
            {
				type: "button",
				text: "Visit Dealer Website",
				theme: "ToyotaBlack",
				isActive: true,
				disableRouter: true,
				href: "{redirect}",
			},
            {
				type:  "button",
				text:  "Change Dealer",
				theme:  "ToyotaWhite",
				isActive: true,
				href: "{showChangeDealer}",
			},
		],
        },
        telephoneNames,
        errorBanner: {
            header: dealer?.contactDealerMessage,
            subheader: "Please contact {dealerName} at <a href={`tel:${phoneNumber}`}>{phoneNumber}</a> to make an appointment, or select another dealer.",//TODO: REPLACE WHEN THERE IS AUTHORED
            noPhoneNumberSubheader: "Please contact {dealerName} to make an appointment, or select another dealer.",
            color: "#F5DADA",
            iconColor: "#EB0A1E",
            iconUrl: general?.errorAlertIcon?.src || general?.maxAppointmentsIcon?.src,
            websiteCopy: isLexus ? "VISIT DEALER WEBSITE" : "Visit Dealer Website",
            iconArrowRight: isLexus ? undefined : `${iconPath}/iconArrowRight.svg`
        },
        invalidZipCopy: dealer?.invalidZipCodeError,
        amenities: dealer?.amenitySections?.map(amenity => ({ displayName: amenity?.label, key: amenity?.key })),
        noDealersIcon: dealer?.noDealersFoundErrorMessageIcon?.src,
        noDealersCopy: dealer?.noDealersFoundErrorMessage,
        noDealersServiceErrorCopy: dealer?.noDealersServiceErrorCopy || (isLexus) ? "OUR APOLOGIES, WE ARE CURRENTLY EXPERIENCING TECHNICAL DIFFICULTIES. <br /> <span style=\"font-family:nobel;font-weight:400;font-size:14px; padding-top: 20px;\">Please check back momentarily.</span>" : "Our apologies, we are currently experiencing some technical difficulties. Please check back momentarily.",
        clearButton: dealer?.clearIcon || `${iconPath}/Utilty-Icon.svg`, //TODO: Missing Prop
        tooltipCopy: dealer?.smartPathTooltip || `<div style="font-family: ToyotaTypeReact; font-size: 12px; line-height: 18px;">
												<img src="${iconPath}/smartpath_logo.svg" alt="SmartPath" title="SmartPath" style="margin-bottom: 16px;" />
												<h2 style="font: inherit; line-height: 18px; margin: 0; font-weight: bold;">The SmartPath Dealer difference</h2>
												<hr style="width: 100%; height: 1px; background: #d8d8d8; display: block; border: none; margin: 16px 0;" />
												<p>Enjoy the ease of a new car-buying experience.</p>
												<ul style="list-style: none; padding: 0;margin-bottom: 8px;">
												<li style="display: flex;"><span style="margin: 0 16px 0 8px">•</span>Transparent and customizable pricing</li>
												<li style="display: flex;"><span style="margin: 0 16px 0 8px">•</span>Flexibility to complete your purchase at the dealer or fully online</li>
												</ul>
												<a style="font-weight: 600;text-decoration: underline;" href="http://toyota.com/smartpath/how-it-works" target="_blank">Learn more</a>
											</div>`,
        smartPathIcon: dealer?.smartPathIcon,
        copyIcon: general?.copyIcon,
        dealerSearchPlaceholder: general?.dealerSearchPlaceholder || "Enter City, Zip, or Dealer Name",
        setPreferredDealerText: isLexus ? "SET AS PREFERRED DEALER" : "Set as Preferred Dealer"
    };
};

const transformMileageEntryPage = ({ mileage, general, theme, dealer, accountCompletionForm }, iconPath) => {
    
   const instructionList = accountCompletionForm?.vinSection?.instructionsSection?.steps?.map(step => {
        return {
            title: step?.heading,
            body: step?.text,
            urlImage: step?.media?.image?.desktop?.src
        }
    });
   
    const isLexus = theme === 'LCOM';
   
    return { 
        heading: mileage?.heading,
        subheading: mileage?.subHeading,
        errorMsg: mileage?.numbersOnlyError,
        estimatedMileage: mileage?.estimatedMileage,
        changeVehicleCTA: "Select a different vehicle",
        changeVehicleCTAHref: mileage?.updatePreferredVehicleCTA?.href,
        mergeDealerMileageSteps: dealer?.mergeDealerAndMileageTabs, // may need to remove
        ghostJellyImage: {
            src: general?.ghostJelly?.src,
            alt: general?.ghostJelly?.alt || '',
            role: general?.ghostJelly?.role || '',
        },
        theme: {
            brand: theme === 'LCOM' ? 'Lexus' : 'Toyota',
        },
        sectionSubHeading: mileage?.sectionSubheading || "VEHICLE MILEAGE", //TODO: Missing Prop
        vinCopy: general?.vinCopy,
        changeVehicleModal:{
            garage: {
                navigationLabel: isLexus ? "BACK TO YOUR VEHICLES" : "Back to your vehicles",
                heading:
                    isLexus ? 'YOUR LEXUS VEHICLES { user.vehicles.length > 0 ? <p style="font-family: nobel-book; font-size: 10px; line-height: 12px; padding-top: 10px;">Images shown for illustrative purposes only. Vehicle may not be as shown.</p> : "" }' : "Your Toyota Vehicles",
                tile: {
                    editIcon: {},
                    placeholderImage: {
                        image: {
                            eagerLoad: false,
                            desktop: {
                                src: "https://np-tmna.aemassets.toyota.com/is/image/toyotadev/lexus/images/models/_global/placeholders/placeholder-lexus.png?wid=275&hei=247&fmt=png-alpha",
                                alt: "placeholder vehicle image",
                            },
                        },
                    },
                    primaryVehicleLabel: isLexus ? "PRIMARY VEHICLE" : "Default Vehicle",
                    primaryVehicleCta: {
                        theme: isLexus ? "SecondaryBlack" : "ToyotaSSTSetPreferredVehicle", // ToyotaSSTSetPreferredVehicle does not exist in author yet, we must force it, i set ToyotaSSTTransparent
                        type: "button",
                        text: isLexus ? "SET AS PRIMARY VEHICLE" : "Set As Default Vehicle",
                        href: "{set_preferred_vehicle_action}",
                        target: "_self",
                        isActive: false,
                    },
                    vinLabel: "VIN: {vin}",
                    noVinLabel: "A VIN is required to select this vehicle.",// missing prop
                    vehicleWithVinCtas: [
                        {
                            theme: "SecondaryBlack",
                            type: "text",
                            text: isLexus ? "REMOVE" : "Remove",
                            href: "{remove_vehicle_action}",
                            target: "_self",
                            isActive: false,
                        },
                    ],
                    vehicleWithoutVinCtas: [
                        {
                            theme: "SecondaryBlack",
                            type: "text",
                            text: isLexus ? "ADD VIN" : "Add VIN",
                            href: "{add_vin_route}",
                            target: "_self",
                            isActive: false,
                        },
                        {
                            theme: "SecondaryBlack",
                            type: "text",
                            text: isLexus ? "REMOVE" : "Remove",
                            href: "{remove_vehicle_action}",
                            target: "_self",
                            isActive: false,
                        },
                    ],
                    removalConfirmation: {
                        heading: isLexus ? "THIS VEHICLE WILL BE REMOVED" : "This vehicle will be removed",
                        ctas: [
                            {
                                theme: isLexus ? "PrimaryBlack" : "ToyotaBlack",
                                type: "button",
                                text: isLexus ? "CONFIRM" : "Confirm",
                                href: "{confirm_remove_vehicle_action}",
                                target: "_self",
                                isActive: false,
                            },
                            {
                                theme: isLexus ? "SecondaryBlack" : "ToyotaSSTSetPreferredVehicle", //ToyotaSSTSetPreferredVehicle does not exist in author yet, we must force it, i set ToyotaSSTSetPreferredVehicle
                                type: "button",
                                text: isLexus ? "KEEP VEHICLE" : "Keep Vehicle",
                                href: "{dismiss_remove_vehicle_action}",
                                target: "_self",
                                isActive: false,
                            },
                        ],
                    },
                },
                ctas: [
                    {
                        theme: isLexus ? "PrimaryBlack" : "SSRedBtn", // SSRedBtn does not exist in author yet, we must force it, i set ToyotaSSTTransparent
                        type: "button",
                        text: isLexus ? "ADD NEW VEHICLE" : "Add New Vehicle",
                        href: "{sst_add_vehicle_by_vin_route}",
                        target: "_self",
                        isActive: false,
                    },
                ],
                noPrimaryVehicleMessage: {
                    heading: isLexus ? "PLEASE SELECT A PRIMARY VEHICLE" : "Vehicle Not Selected",
                    text: isLexus ? "To get the most out of My Lexus, you will need to select a primary vehicle." : "To schedule an appointment, you must first select the vehicle to be serviced",
                },
                maxVehiclesMessage: {
                    heading: isLexus ? "OUR APOLOGIES" : "Our Apologies",
                    text: "You have reached the vehicle entry limit for your account. If you have questions or would like to add more vehicles, please contact us.",
                },
                loadingVehiclesFailureMessage: {
                    icon: {
                        color: "#000000",
                        src: isLexus ? "/content/dam/lexus/images/icons/global/error.svg" : `${iconPath}/ErrorIconGray.svg`,
                        altText: "Caution Symbol",
                        markup:
                            '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 28.07 24.1">\n\t<g>\n\t\t<path\n\t\t\td="M37.51,36.85H13.3a1.86,1.86,0,0,1-1.68-1,2.15,2.15,0,0,1,.13-2.19l.05-.07,12-20.21a2.27,2.27,0,0,1,3.14,0l.07.1,12,20.18a2.14,2.14,0,0,1,.16,2.2A1.9,1.9,0,0,1,37.51,36.85ZM24.58,14.05l-12,20.22a1.18,1.18,0,0,0,0,1.11.86.86,0,0,0,.8.47H37.51a.88.88,0,0,0,.82-.46,1.15,1.15,0,0,0-.07-1.13l-.07-.09-12-20.12A1.26,1.26,0,0,0,24.58,14.05Z"\n\t\t\ttransform="translate(-11.38 -12.75)" />\n\t\t<rect x="13.17" y="9.31" width="1.73" height="5.94" />\n\t\t<rect x="13.17" y="17.24" width="1.73" height="1.94" />\n\t</g>\n</svg>',
                    },
                    heading: isLexus ? "WE APOLOGIZE" : "We Apologize",
                    text: "We are currently unable to retrieve your vehicles. Please give us a moment and try again later.",
                },
                editNicknameFailureMessage: {
                    heading: isLexus ? "UNABLE TO SAVE NICKNAME" : "Unable to Save Nickname",
                    text: isLexus ? "Our apologies. Please try again later." : "Our Apologies. Please try again later as we resolve this issue.",
                },
                setPrimaryVehicleFailureMessage: {
                    heading: isLexus ? "VEHICLE NOT SET AS PRIMARY VEHICLE" : "Vehicle Not Selected",
                    text: isLexus ? "Our apologies. Please try again later." : "Our Apologies. Please try again later as we resolve this issue.",
                },
                removeVehicleFailureMessage: {
                    heading: isLexus ? "UNABLE TO REMOVE VEHICLE" : "Unable to remove vehicle",
                    text: isLexus ? "Our apologies. Please try again later." : "Our apologies. Please try again later as we resolve this issue",
                },
                mappedErrorMessages: [
                    {
                        errorCode: "B009",
                        heading: "Active Subscription",
                        text: "Due to an active subscription associated with this VIN, we are unable to remove this vehicle from your account. For assistance, please contact customer support at 1-800-255-3987.",
                    },
                    {
                        errorCode: "V035",
                        heading: "Invalid VIN",
                        text: "Temporary VINs are not accepted. Please enter your 17-character VIN found on your insurance card, registration card, the top of your dashboard or the driver's-side doorjamb.",
                    },
                ],
            },
            sstAddVehicleByVin: {
                navigationLabel: "Back to Add Vehicle",
                heading: isLexus ? "ADD VEHICLE": "Add Vehicle",
                text: "Please enter your Vehicle Identification Number (VIN) to access current information about your vehicle.",
                vinTab: {
                    label: "VIN",
                    entryHint: isLexus ? "ENTER YOUR 17-CHARACTER VIN" : "Enter your 17-Character VIN",
                    explanationHeading: isLexus ? "WHERE IS MY VIN?" : "Where do I find my VIN?",
                    explanationText:
                        "Your VIN is a 17-character set of numbers unique to your vehicle. It can be found on your insurance card, vehicle registration card, the top of your dashboard or the driver's-side doorjamb of your vehicle.",
                    vinValidationErrorMessage: "Please enter a valid 17-character VIN.",
                    submitCta: {
                        theme: isLexus ? "SecondaryBlack": "SSRedBtn",
                        type: "button",
                        text: isLexus ? "ADD VEHICLE" : "Add Vehicle",
                        href: "{{add_vehicle_by_vin_action}}", // SSRedBtn does not exist in author yet, we must force it, i set ToyotaSSTTransparent
                        target: "_self",
                        isActive: true,
                    },
                },
                addVehicleFailureMessage: {
                    heading: isLexus ? "UNABLE TO ADD YOUR VEHICLE" : "Unable to Add Vehicle",
                    text: "Our apologies. Please try again later as we resolve this issue.",
                },
                mappedErrorMessages: [
                    {
                        errorCode: "B009",
                        heading: "Active Subscription",
                        text: "Due to an active subscription associated with this VIN, we are unable to remove this vehicle from your account. For assistance, please contact customer support at 1-800-255-3987.",
                    },
                    {
                        errorCode: "V035",
                        heading: "Invalid VIN",
                        text: "Temporary VINs are not accepted. Please enter your 17-character VIN found on your insurance card, registration card, the top of your dashboard or the driver's-side doorjamb.",
                    },
                ],
                instructionList: instructionList,
                //TODO: Need to add this properties to the backend
                vinScannerButtonProps:{
                    buttonTheme: "ToyotaWhite",
	                buttonCopy: "Scan VIN",
	                buttonIcon: `${iconPath}/cameraIcon.svg`,
                }
            },
            addVIN: {
                heading: isLexus ? "ADD VIN" : "Add VIN",
                text: "Please enter your Vehicle Identification Number (VIN) to access current information about your vehicle.",
                entryHint: isLexus ? "ENTER YOUR 17-CHARACTER VIN": "Enter your 17-Character VIN",
                explanationHeading: isLexus ? "WHERE IS MY VIN?" : "Where do I find my VIN?",
                explanationText:
                    "Your VIN is a 17-character set of numbers unique to your vehicle. It can be found on your insurance card, vehicle registration card, the top of your dashboard or the driver's-side doorjamb of your vehicle.",
                submitCta: {
                    theme: isLexus ? "SecondaryBlack": "SSRedBtn" , // SSRedBtn does not exist in author yet, we must force it, i set ToyotaSSTTransparent
                    type: "button",
                    text: isLexus ? "ADD VIN" : "Add VIN",
                    href: "{{add_vin_action}}",
                    target: "_self",
                    isActive: false,
                },
                vinValidationErrorMessage: "Please enter a valid 17-character VIN.",
                addVINFailureMessage: {
                    heading: isLexus ? "UNABLE TO UPDATE YOUR VEHICLE" : "Unable to update your vehicle",
                    text: "Our apologies. Please try again later as we resolve this issue.",
                },
                mappedErrorMessages: [
                    {
                        errorCode: "B009",
                        heading: "Active Subscription",
                        text: "Due to an active subscription associated with this VIN, we are unable to remove this vehicle from your account. For assistance, please contact customer support at 1-800-255-3987.",
                    },
                    {
                        errorCode: "V035",
                        heading: "Invalid VIN",
                        text: "Temporary VINs are not accepted. Please enter your 17-character VIN found on your insurance card, registration card, the top of your dashboard or the driver's-side doorjamb.",
                    },
                ],
                instructionList: instructionList,
                //TODO: Need to add this properties to the backend
                 vinScannerButtonProps:{
                    buttonTheme: "ToyotaWhite",
	                buttonCopy: "Scan VIN",
	                buttonIcon: `${iconPath}/cameraIcon.svg`,
                }
            },
        }

    } 
}


const transformServicesPage = ({ services, general }) => {

    return {
        heading: services?.heading,
        subheading: services?.subHeading,
        selectAllLabel: services?.selectAll,
        contactDealerLabel: services?.contactDealerForPrice,
        noServicesMessageIcon: services?.noServicesIcon?.src,
        estimatedTotalLabel: services?.estimatedTotal,
        tooltipIcon: services?.toolTipIcon?.src,
        tooltipIconMessage: services?.toolTipMessage,
        contactDealerMessage: services?.contactDealerMessage,
        customServicePlaceholder: services?.customServiceSectionInput,
        searchBarLabel: services?.searchBoxLabel,
        searchBarIcon: {
            src: services?.searchBoxIcon?.src,
            alt: services?.searchBoxIcon?.altText,
            color: services?.searchBoxIcon?.color
        },
        noResultsTitle: services?.noResultsHeading,
        noResultsMessage: services?.noResultsSubHeading,
        noResultsIcon: {
            src: services?.noResultsIcon?.src,
            alt: services?.noResultsIcon?.altText,
            color: services?.noResultsIcon?.color
        },
        tabs: [
            {
                title: services?.tab1,
                sections: [
                    {
                        panelTitle: services?.tab1Section1Copy,
                        panelSubtitle: services?.tab1Section1Subcopy,
                        noServicesAvailable: services?.tab1NoServices,
                        id: services?.tab1Section1Id
                    },
                    {
                        panelTitle: services?.tab1Section2Copy,
                        panelSubtitle: services?.tab1Section2Subcopy,
                        noServicesAvailable: services?.tab1NoServicesNoDealer,
                        id: services?.tab1Section2Id
                    }
                ]
            }, {
                title: services?.tab2,
                sections: [
                    {
                        noServicesAvailable: services?.tab2NoServices,
                        id: "generalRecommendedServiceList" // TODO: Missing tab2Section1Id TODO: VALIDATE WHY IS NOT BRINGING DATA
                    }
                ]
            }
        ],
        telephoneIcon: services?.contactDealerIcon?.src,
        customServiceLabel: services?.customServiceSection,
    }
}


// TODO: Check if state options needs to be replaced in Component.
const defaultStateOptions = [
    {
        displayValue: "Alabama",
        value: "AL",
    },
    {
        displayValue: "Alaska",
        value: "AK",
    },
    {
        displayValue: "Arizona",
        value: "AZ",
    },
    {
        displayValue: "Arkansas",
        value: "AR",
    },
    {
        displayValue: "California",
        value: "CA",
    },
    {
        displayValue: "Colorado",
        value: "CO",
    },
    {
        displayValue: "Connecticut",
        value: "CT",
    },
    {
        displayValue: "Delaware",
        value: "DE",
    },
    {
        displayValue: "Florida",
        value: "FL",
    },
    {
        displayValue: "Georgia",
        value: "GA",
    },
    {
        displayValue: "Hawaii",
        value: "HI",
    },
    {
        displayValue: "Idaho",
        value: "ID",
    },
    {
        displayValue: "Illinois",
        value: "IL",
    },
    {
        displayValue: "Indiana",
        value: "IN",
    },
    {
        displayValue: "Iowa",
        value: "IA",
    },
    {
        displayValue: "Kansas",
        value: "KS",
    },
    {
        displayValue: "Kentucky",
        value: "KY",
    },
    {
        displayValue: "Louisiana",
        value: "LA",
    },
    {
        displayValue: "Maine",
        value: "ME",
    },
    {
        displayValue: "Maryland",
        value: "MD",
    },
    {
        displayValue: "Massachusetts",
        value: "MA",
    },
    {
        displayValue: "Michigan",
        value: "MI",
    },
    {
        displayValue: "Minnesota",
        value: "MN",
    },
    {
        displayValue: "Mississippi",
        value: "MS",
    },
    {
        displayValue: "Missouri",
        value: "MO",
    },
    {
        displayValue: "Montana",
        value: "MT",
    },
    {
        displayValue: "Nebraska",
        value: "NE",
    },
    {
        displayValue: "Nevada",
        value: "NV",
    },
    {
        displayValue: "New Hampshire",
        value: "NH",
    },
    {
        displayValue: "New Jersey",
        value: "NJ",
    },
    {
        displayValue: "New Mexico",
        value: "NM",
    },
    {
        displayValue: "New York",
        value: "NY",
    },
    {
        displayValue: "North Carolina",
        value: "NC",
    },
    {
        displayValue: "North Dakota",
        value: "ND",
    },
    {
        displayValue: "Ohio",
        value: "OH",
    },
    {
        displayValue: "Oklahoma",
        value: "OK",
    },
    {
        displayValue: "Oregon",
        value: "OR",
    },
    {
        displayValue: "Palau",
        value: "PW",
    },
    {
        displayValue: "Pennsylvania",
        value: "PA",
    },
    {
        displayValue: "Puerto Rico",
        value: "PR",
    },
    {
        displayValue: "Rhode Island",
        value: "RI",
    },
    {
        displayValue: "South Carolina",
        value: "SC",
    },
    {
        displayValue: "South Dakota",
        value: "SD",
    },
    {
        displayValue: "Tennessee",
        value: "TN",
    },
    {
        displayValue: "Texas",
        value: "TX",
    },
    {
        displayValue: "Utah",
        value: "UT",
    },
    {
        displayValue: "Vermont",
        value: "VT",
    },
    {
        displayValue: "Virginia",
        value: "VA",
    },
    {
        displayValue: "Washington",
        value: "WA",
    },
    {
        displayValue: "West Virginia",
        value: "WV",
    },
    {
        displayValue: "Wisconsin",
        value: "WI",
    },
    {
        displayValue: "Wyoming",
        value: "WY",
    },
];

const transformSchedulePage = ({ dateTime, general, theme }, iconPath) => {

    const address = {
        addressLine1: dateTime?.address1Input,
        addressLine2: dateTime?.address2Input,
        city: dateTime?.cityDropdown,
        state: dateTime?.stateDropdown,
        zip: dateTime?.zipInput,
        requiredFields: dateTime?.requiredFields,
    }
    const tabs = dateTime?.timeTabList?.map(timeTab => ({ id: timeTab.toLowerCase(), title: timeTab }));

    return {
        heading: dateTime?.heading,
        subheading: dateTime?.subHeading,
        formLabels: {
            providerTransportationLabel: dateTime?.serviceTransportationMessage,
            advisorDropdownLabel: dateTime?.advisorDropdown,
            advisorDropdownErrorMessage: '', // TODO:
            transportationDropdownLabel: dateTime?.transportationDropdown,
            transportationDropdownErrorMessage: '', // TODO:
            dateLabel: dateTime?.selectDate,
            timeLabel: dateTime?.selectTime,
            datePickerLabel: dateTime?.dateDropdown
        },
        formErrors: {
            dateField: {
                invalid: dateTime?.invalidErrorMessage || 'Please enter a valid date',
                empty: dateTime?.emptyErrorMessage || 'Must select a date',
                pastDate: dateTime?.pastDateErrorMessage || 'Must select a date in the future',
                dateMaxLimit: dateTime?.dateDropdownToFarInFutureErrorMessage || 'Please choose a valid date within 180 days',
            }
        },
        pickUpAndDeliveryForm: {
            formLabels: {
                pickUpAddress: {
                    ...address,
                    borderColor: "#FFFFF",
                    addressLabel: dateTime?.pickupMessage,
                    addressBody: dateTime?.pickupMessageSubcopy,
                    outOfRangeErrorMessage: dateTime?.outOfRangeErrorMessage
                },
                deliveryAddress: {
                    ...address,
                    borderColor: "#D8D8D8",
                    addressLabel: dateTime?.deliveryMessage,
                    outOfRangeErrorMessage: dateTime?.outOfRangeErrorMessage
                },
                deliveryAddressLabelBtn: dateTime?.deliveryCheckbox,
            },
            stateOptions: defaultStateOptions
        },
        deliveryForm: {
            formLabels: {
                ...address,
                borderColor: "#FFFFF",
                addressLabel: dateTime?.deliveryMessage,
                addressBody: dateTime?.deliveryMessageSubcopy,
                outOfRangeErrorMessage: dateTime?.outOfRangeErrorMessage
            }
        },
        pickUpForm: {
            formLabels: {
                ...address,
                borderColor: "#FFFFF",
                addressLabel: dateTime?.pickupMessage,
                addressBody: dateTime?.pickupMessageSubcopy,
                outOfRangeErrorMessage: dateTime?.outOfRangeErrorMessage
            }
        },
        rentalOrLoaner: {
            header: dateTime?.renterLoaner,
            subheader: dateTime?.renterLoanerSubcopy,
            iconColor: "#EB0A1E",
            iconUrl: dateTime?.renterLoanerIcon?.src
        },
        tabs,
        days: dateTime?.days || 90,
        months: dateTime?.months || 3,
        iconCalendar: dateTime?.calendarIcon?.src,
        iconDateDropdown: dateTime?.dropdownOpenIcon?.src,
        unavailabilityAppointmentMessage: dateTime?.noAppointmentsPartOfDay,
        noDayAppointmentMessage: dateTime?.noAppointmentsAvailable,
        timeslotFormat: dateTime?.timeFormat,
        scheduleTimeFormat: dateTime?.appointmentSummaryFormat,
        noDateMessage: dateTime?.noDateMessage,
        maxDailyAppointments: {
            title: general?.maxDailyAppointmentsHeading,
            body: general?.maxDailyAppointments,
            iconColor: '',
            iconUrl: general?.maxDailyAppointmentsIcon?.src,
            CTAButtonLabel: general?.maxDailyAppointmentsCTA?.text,
            CTAButtonRedirect: general?.maxDailyAppointmentsCTA?.href,
            CTAButtonTheme: general?.maxDailyAppointmentsCTA?.theme
        },
        showAdvisorAvatar: false,
        errorMessageIcon: dateTime?.errorMessageIcon,
    }
}

const transformSummaryPage = ({ summary, dateTime, theme, general, bookAppointmentCTA }, iconPath) => {
    return {
        heading: summary?.heading,
        subheading: summary?.subHeading,
        confirmHeading: summary?.confirmEditHeading,
        confirmSubheading: summary?.confirmEditSubHeading,
        editHeading: summary?.editHeading,
        editSubheading: summary?.editSubHeading,
        vinCopy: summary?.vinCopy,
        additionalCommentsPlaceHolder: summary?.additionalComments,
        editAppointmentCTAText: summary?.editAppointmentCTA?.text,
        bookAppointmentCTAText: bookAppointmentCTA?.text,
        pickUpCopy: summary?.pickupCopy,
        deliveryCopy: summary?.deliveryCopy,
        pickupAndDeliveryCopy: summary?.pickupAndDeliveryCopy,
        ghostJellyImage: {
            src: general?.ghostJelly?.src,
            alt: general?.ghostJelly?.alt || '',
            role: general?.ghostJelly?.role || '',
        },
        summaryItemList: summary?.sectionBlocks?.map(section => {
            return {
                heading: section.label,
                content: section?.key,
                editLabel: summary?.edit,
                stepIndex: section?.step,
                icon: section?.icon,
                editable: section.isEditable
            };
        }) || [],
        customServiceCopy: summary?.customServiceCopy,
        scheduleTimeFormat: dateTime?.appointmentSummaryFormat
    }
}

const transformNoVinOrAddress = ({ accountCompletionForm }, iconPath) => {

    const { heading, subHeading, continueCta, requiredFieldsText, addressSection, vinSection, noVinDisclaimer } = accountCompletionForm;
    const instructionList = vinSection?.instructionsSection?.steps?.map(step => {
        return {
            title: step?.heading,
            body: step?.text,
            urlImage: step?.media?.image?.desktop?.src
        }
    });



    const addressFormProps = {
        title: addressSection?.heading,
        subtitle: addressSection?.subHeading,
        requiredFieldLabel: requiredFieldsText,
        addressLine1Label: addressSection?.addressLineOneLabel,
        addressLine2Label: addressSection?.addressLineTwoLabel,
        cityLabel: addressSection?.cityLabel,
        stateLabel: addressSection?.stateLabel,
        zipLabel: addressSection?.zipCodeLabel,
        requiredFieldMessage: `<Icon src="${iconPath}/warningIconRed.svg"/> Required Field`,// TODO: Missing prop
    };

    const vinFormProps = {
        title: vinSection?.heading,
        subtitle: vinSection?.subHeading,
        accordionLabel: vinSection?.instructionsSection?.heading,
        vinLabel: vinSection?.vinLabel,
        vinErrorMessage: vinSection?.vinErrorMessage, //`<Icon src="${Icon}"/> Invalid VIN entry, please try again.`
        instructionList,
        instructionDescription: vinSection?.description
    };
    const noVinOrAddress = {
        title: heading,
        subtitle: subHeading,
        CTAButtonLabel: continueCta?.text,
        addressFormProps,
        vinFormProps,
        noVinDisclaimer
    }
    return noVinOrAddress;
}


const transformData = (props) => {

    const LCOM = 'LCOM';
    const { theme, general, viewAppointmentsCTA, dealer, mileage, summary: { cancelEditorCTA }, loadingState } = props;
    const source = theme;
    const brand = source === LCOM ? 'L' : 'T';

    const { subSections } = mileage;
    // Aux var to get the icons baseURL based on source
    const iconPath = getIconPath(source);
    const dealerSelectionPage = transformDealerPage(props, iconPath);
    const mileageEntryPage = transformMileageEntryPage(props, iconPath);
    const servicesPage = transformServicesPage(props);
    const schedulePage = transformSchedulePage(props, iconPath);
    const summaryPage = transformSummaryPage(props, iconPath);

    const mergeDealerMileagePage = {
        heading: mileage?.heading || "VEHICLE DETAILS", //TODO: missing CMS prop
        subheading: mileage?.subHeading || "Confirm the vehicle, mileage, and dealer for your service appointment.", //TODO: missing CMS prop
        mileageEntryPage: {
            ...mileageEntryPage,
            sectionHeading: subSections?.mileage?.heading
        },
        dealerSelectionPage: {
            ...dealerSelectionPage,
            sectionHeading: subSections?.dealer?.heading,
            sectionSubheading: subSections?.dealer?.subHeading
        }
    }

    const cancelEditor = {
        label: cancelEditorCTA?.text,
        icon: source === LCOM ? undefined : cancelEditorCTA?.icon || `${iconPath}/iconArrowLeft.svg`, //TODO: Missing Prop cancelEditorCTAIcon
        redirectURL: viewAppointmentsCTA?.href,
    }

    //TODO: Missing CMS prop
    const VinScannerButton = {
        buttonTheme: "ToyotaWhite",
	    buttonCopy: "Scan VIN",
	    buttonIcon: `${iconPath}/cameraIcon.svg`,
    }

    // TODO: Missing CMS prop, still missing the icons.
    const additionalCommentsProps = {
        enabled: true,
        heading: general.additionalCommentsFieldHeading, 
        additionalCommentsPlaceHolder: general.additionalCommentsPlaceholderText,
        editCommentCTA: general.editCommentsLabelCTA?.text,
        addAdditionalCommentCTA:  general.additionalCommentsLabelCTA?.text,
        additionalCommentsIcons: "", 
        editCommentsIcons: "",
    }

    return {
        source,
        brand,
        cancelEditor,
        VinScannerButton,
        additionalCommentsProps,
        serverErrorMessage: {
            title: general.serverErrorMessageHeading,
            subtitle: general.serverErrorMessageCopy,
        },
        theme: {
            brand: source === LCOM ? 'Lexus' : 'Toyota',
        },
        isMapEnabled: dealer?.enableMap,
        mergeDealerMileageSteps: dealer?.mergeDealerAndMileageTabs,
        loader: {
            indeterminateIcon: loadingState?.loaderIndeterminateIcon?.src,
            indeterminateText: loadingState?.loaderIndeterminateText
        },
        pricing: general?.enablePricing,
        noVinOrAddress: transformNoVinOrAddress(props, iconPath),
        processStepper: transformProcessStepper(props, iconPath),
        dealerSelectionPage,
        mileageEntryPage,
        servicesPage,
        schedulePage,
        summaryPage,
        mergeDealerMileagePage
    }
}


const SchedulerToolConfig = (props) => {
    const data = transformData(props);
    return <Component {...data} />;
};

export default withAemIntegration("lexus/components/service-scheduler-tool")(SchedulerToolConfig, SchedulerToolEditConfig);
